import React from 'react';
import CustomCircularProgress from '../common/CustomCircularProgress';
import LowboyResourceCards from './LowboyResourceCards';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import LowboyDispatchScoreboard from './LowboyDispatchScoreboard';
import { MomentDateFormat } from '../MomentDateFormat';
import moment from 'moment';

export default class LowboyResourcePane extends React.Component {
    allAssignmentsFilled() {
        const { lowboyResources, lowboyAssignments } = this.props;

        return (
            lowboyResources &&
            lowboyResources.length > 0 &&
            lowboyResources.every(
                (lr) =>
                    lr.requestedResourceCount == lr.lowboyAssignmentIds.length
            ) &&
            lowboyAssignments.every((la) => la.employeeId)
        );
    }

    render() {
        const { lowboyResources, resourcesLoading, activeDate } = this.props;

        return (
            <div className="resource-container">
                <div className="resource-pane">
                    <legend className="d-flex flex-row align-items-center">
                        Resources -{' '}
                        {moment(activeDate).format(
                            MomentDateFormat.WeekDayNameAndDate
                        )}
                    </legend>
                    <div className="p-1">
                        {resourcesLoading && <CustomCircularProgress />}

                        {!resourcesLoading && (
                            <LowboyDispatchScoreboard {...this.props} />
                        )}

                        {!resourcesLoading && lowboyResources.length == 0 && (
                            <>No lowboy moves are needed.</>
                        )}

                        {!resourcesLoading && this.allAssignmentsFilled() && (
                            <div className="mt-2 d-flex">
                                <div className="p-2">
                                    <FontAwesomeIcon icon={faThumbsUp} />
                                </div>
                                <div className="p-2">
                                    All requests have been filled.
                                </div>
                            </div>
                        )}

                        {!resourcesLoading &&
                            lowboyResources.length > 0 && (
                            <div className="resource-cards-scroll-wrapper">
                                {lowboyResources.map((lr, i) => (
                                    <LowboyResourceCards
                                        key={`${lr.id}-${i}`}
                                        lowboyResource={lr}
                                        cardsIndex={i}
                                        {...this.props}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
